import {
    Category_1_Products,
    Category_2_Products,
    Category_3_Products,
    Category_4_Products,
    Category_5_Products,
    Category_6_Products,
    Category_7_Products,
    Category_8_Products,
    Category_9_Products,
    Category_10_Products,
    Category_11_Products,
    Category_12_Products,
    Category_13_Products,
    Category_14_Products,
    Category_15_Products,
    Category_16_Products
} from './keys';

export const ProductsNavData = [
    {
        "key": `${Category_1_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_1_Products.product_1.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_1.key}`
            },
            {
                "title": `${Category_1_Products.product_2.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_2.key}`
            },
            {
                "title": `${Category_1_Products.product_3.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_3.key}`
            },
            {
                "title": `${Category_1_Products.product_4.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_4.key}`
            },
            {
                "title": `${Category_1_Products.product_5.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_5.key}`
            },
            {
                "title": `${Category_1_Products.product_6.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_6.key}`
            },
            {
                "title": `${Category_1_Products.product_7.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_7.key}`
            },
            {
                "title": `${Category_1_Products.product_8.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_8.key}`
            },
            {
                "title": `${Category_1_Products.product_9.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_9.key}`
            },
            {
                "title": `${Category_1_Products.product_10.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_10.key}`
            },
            {
                "title": `${Category_1_Products.product_11.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_11.key}`
            },
            {
                "title": `${Category_1_Products.product_12.title}`,
                "link": `/product/${Category_1_Products.parentKey}/${Category_1_Products.product_12.key}`
            }
        ]
    },
    {
        "key": `${Category_2_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_2_Products.product_1.title}`,
                "link": `/product/${Category_2_Products.parentKey}/${Category_2_Products.product_1.key}`
            },
            {
                "title": `${Category_2_Products.product_2.title}`,
                "link": `/product/${Category_2_Products.parentKey}/${Category_2_Products.product_2.key}`
            },
            {
                "title": `${Category_2_Products.product_3.title}`,
                "link": `/product/${Category_2_Products.parentKey}/${Category_2_Products.product_3.key}`
            },
            {
                "title": `${Category_2_Products.product_4.title}`,
                "link": `/product/${Category_2_Products.parentKey}/${Category_2_Products.product_4.key}`
            },
            {
                "title": `${Category_2_Products.product_5.title}`,
                "link": `/product/${Category_2_Products.parentKey}/${Category_2_Products.product_5.key}`
            },
            {
                "title": `${Category_2_Products.product_6.title}`,
                "link": `/product/${Category_2_Products.parentKey}/${Category_2_Products.product_6.key}`
            },
            {
                "title": `${Category_2_Products.product_7.title}`,
                "link": `/product/${Category_2_Products.parentKey}/${Category_2_Products.product_7.key}`
            },
            {
                "title": `${Category_2_Products.product_8.title}`,
                "link": `/product/${Category_2_Products.parentKey}/${Category_2_Products.product_8.key}`
            },
            {
                "title": `${Category_2_Products.product_9.title}`,
                "link": `/product/${Category_2_Products.parentKey}/${Category_2_Products.product_9.key}`
            }
        ]
    },
    {
        "key": `${Category_3_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_3_Products.product_1.title}`,
                "link": `/product/${Category_3_Products.parentKey}/${Category_3_Products.product_1.key}`
            },
            {
                "title": `${Category_3_Products.product_2.title}`,
                "link": `/product/${Category_3_Products.parentKey}/${Category_3_Products.product_2.key}`
            },
            {
                "title": `${Category_3_Products.product_3.title}`,
                "link": `/product/${Category_3_Products.parentKey}/${Category_3_Products.product_3.key}`
            },
            {
                "title": `${Category_3_Products.product_4.title}`,
                "link": `/product/${Category_3_Products.parentKey}/${Category_3_Products.product_4.key}`
            },
            {
                "title": `${Category_3_Products.product_5.title}`,
                "link": `/product/${Category_3_Products.parentKey}/${Category_3_Products.product_5.key}`
            },
            {
                "title": `${Category_3_Products.product_6.title}`,
                "link": `/product/${Category_3_Products.parentKey}/${Category_3_Products.product_6.key}`
            },
            {
                "title": `${Category_3_Products.product_7.title}`,
                "link": `/product/${Category_3_Products.parentKey}/${Category_3_Products.product_7.key}`
            }
        ]
    },
    {
        "key": `${Category_4_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_4_Products.product_1.title}`,
                "link": `/product/${Category_4_Products.parentKey}/${Category_4_Products.product_1.key}`
            },
            {
                "title": `${Category_4_Products.product_2.title}`,
                "link": `/product/${Category_4_Products.parentKey}/${Category_4_Products.product_2.key}`
            },
            {
                "title": `${Category_4_Products.product_3.title}`,
                "link": `/product/${Category_4_Products.parentKey}/${Category_4_Products.product_3.key}`
            },
            {
                "title": `${Category_4_Products.product_4.title}`,
                "link": `/product/${Category_4_Products.parentKey}/${Category_4_Products.product_4.key}`
            },
            {
                "title": `${Category_4_Products.product_5.title}`,
                "link": `/product/${Category_4_Products.parentKey}/${Category_4_Products.product_5.key}`
            },
            {
                "title": `${Category_4_Products.product_6.title}`,
                "link": `/product/${Category_4_Products.parentKey}/${Category_4_Products.product_6.key}`
            },
            {
                "title": `${Category_4_Products.product_7.title}`,
                "link": `/product/${Category_4_Products.parentKey}/${Category_4_Products.product_7.key}`
            },
            {
                "title": `${Category_4_Products.product_8.title}`,
                "link": `/product/${Category_4_Products.parentKey}/${Category_4_Products.product_8.key}`
            },
            {
                "title": `${Category_4_Products.product_9.title}`,
                "link": `/product/${Category_4_Products.parentKey}/${Category_4_Products.product_9.key}`
            },
            {
                "title": `${Category_4_Products.product_10.title}`,
                "link": `/product/${Category_4_Products.parentKey}/${Category_4_Products.product_10.key}`
            },
            {
                "title": `${Category_4_Products.product_11.title}`,
                "link": `/product/${Category_4_Products.parentKey}/${Category_4_Products.product_11.key}`
            }
        ]
    },
    {
        "key": `${Category_5_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_5_Products.product_1.title}`,
                "link": `/product/${Category_5_Products.parentKey}/${Category_5_Products.product_1.key}`
            },
            {
                "title": `${Category_5_Products.product_2.title}`,
                "link": `/product/${Category_5_Products.parentKey}/${Category_5_Products.product_2.key}`
            },
            {
                "title": `${Category_5_Products.product_3.title}`,
                "link": `/product/${Category_5_Products.parentKey}/${Category_5_Products.product_3.key}`
            },
            {
                "title": `${Category_5_Products.product_4.title}`,
                "link": `/product/${Category_5_Products.parentKey}/${Category_5_Products.product_4.key}`
            },
            {
                "title": `${Category_5_Products.product_5.title}`,
                "link": `/product/${Category_5_Products.parentKey}/${Category_5_Products.product_5.key}`
            },
            {
                "title": `${Category_5_Products.product_6.title}`,
                "link": `/product/${Category_5_Products.parentKey}/${Category_5_Products.product_6.key}`
            },
            {
                "title": `${Category_5_Products.product_7.title}`,
                "link": `/product/${Category_5_Products.parentKey}/${Category_5_Products.product_7.key}`
            }
        ]
    },
    {
        "key": `${Category_6_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_6_Products.product_1.title}`,
                "link": `/product/${Category_6_Products.parentKey}/${Category_6_Products.product_1.key}`
            },
            {
                "title": `${Category_6_Products.product_2.title}`,
                "link": `/product/${Category_6_Products.parentKey}/${Category_6_Products.product_2.key}`
            },
            {
                "title": `${Category_6_Products.product_3.title}`,
                "link": `/product/${Category_6_Products.parentKey}/${Category_6_Products.product_3.key}`
            },
            {
                "title": `${Category_6_Products.product_4.title}`,
                "link": `/product/${Category_6_Products.parentKey}/${Category_6_Products.product_4.key}`
            },
            {
                "title": `${Category_6_Products.product_5.title}`,
                "link": `/product/${Category_6_Products.parentKey}/${Category_6_Products.product_5.key}`
            },
            {
                "title": `${Category_6_Products.product_6.title}`,
                "link": `/product/${Category_6_Products.parentKey}/${Category_6_Products.product_6.key}`
            },
            {
                "title": `${Category_6_Products.product_7.title}`,
                "link": `/product/${Category_6_Products.parentKey}/${Category_6_Products.product_7.key}`
            }
        ]
    },
    {
        "key": `${Category_7_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_7_Products.product_1.title}`,
                "link": `/product/${Category_7_Products.parentKey}/${Category_7_Products.product_1.key}`
            },
            {
                "title": `${Category_7_Products.product_2.title}`,
                "link": `/product/${Category_7_Products.parentKey}/${Category_7_Products.product_2.key}`
            },
            {
                "title": `${Category_7_Products.product_3.title}`,
                "link": `/product/${Category_7_Products.parentKey}/${Category_7_Products.product_3.key}`
            },
            {
                "title": `${Category_7_Products.product_4.title}`,
                "link": `/product/${Category_7_Products.parentKey}/${Category_7_Products.product_4.key}`
            },
            {
                "title": `${Category_7_Products.product_5.title}`,
                "link": `/product/${Category_7_Products.parentKey}/${Category_7_Products.product_5.key}`
            },
            {
                "title": `${Category_7_Products.product_6.title}`,
                "link": `/product/${Category_7_Products.parentKey}/${Category_7_Products.product_6.key}`
            },
            {
                "title": `${Category_7_Products.product_7.title}`,
                "link": `/product/${Category_7_Products.parentKey}/${Category_7_Products.product_7.key}`
            }
        ]
    },
    {
        "key": `${Category_8_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_8_Products.product_1.title}`,
                "link": `/product/${Category_8_Products.parentKey}/${Category_8_Products.product_1.key}`
            },
            {
                "title": `${Category_8_Products.product_2.title}`,
                "link": `/product/${Category_8_Products.parentKey}/${Category_8_Products.product_2.key}`
            },
            {
                "title": `${Category_8_Products.product_3.title}`,
                "link": `/product/${Category_8_Products.parentKey}/${Category_8_Products.product_3.key}`
            },
            {
                "title": `${Category_8_Products.product_4.title}`,
                "link": `/product/${Category_8_Products.parentKey}/${Category_8_Products.product_4.key}`
            },
            {
                "title": `${Category_8_Products.product_5.title}`,
                "link": `/product/${Category_8_Products.parentKey}/${Category_8_Products.product_5.key}`
            },
            {
                "title": `${Category_8_Products.product_6.title}`,
                "link": `/product/${Category_8_Products.parentKey}/${Category_8_Products.product_6.key}`
            },
            {
                "title": `${Category_8_Products.product_7.title}`,
                "link": `/product/${Category_8_Products.parentKey}/${Category_8_Products.product_7.key}`
            },
            {
                "title": `${Category_8_Products.product_8.title}`,
                "link": `/product/${Category_8_Products.parentKey}/${Category_8_Products.product_8.key}`
            },
            {
                "title": `${Category_8_Products.product_9.title}`,
                "link": `/product/${Category_8_Products.parentKey}/${Category_8_Products.product_9.key}`
            },
            {
                "title": `${Category_8_Products.product_10.title}`,
                "link": `/product/${Category_8_Products.parentKey}/${Category_8_Products.product_10.key}`
            },
            {
                "title": `${Category_8_Products.product_11.title}`,
                "link": `/product/${Category_8_Products.parentKey}/${Category_8_Products.product_11.key}`
            }
        ]
    },
    {
        "key": `${Category_9_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_9_Products.product_1.title}`,
                "link": `/product/${Category_9_Products.parentKey}/${Category_9_Products.product_1.key}`
            },
            {
                "title": `${Category_9_Products.product_2.title}`,
                "link": `/product/${Category_9_Products.parentKey}/${Category_9_Products.product_2.key}`
            },
            {
                "title": `${Category_9_Products.product_3.title}`,
                "link": `/product/${Category_9_Products.parentKey}/${Category_9_Products.product_3.key}`
            },
            {
                "title": `${Category_9_Products.product_4.title}`,
                "link": `/product/${Category_9_Products.parentKey}/${Category_9_Products.product_4.key}`
            },
            {
                "title": `${Category_9_Products.product_5.title}`,
                "link": `/product/${Category_9_Products.parentKey}/${Category_9_Products.product_5.key}`
            },
            {
                "title": `${Category_9_Products.product_6.title}`,
                "link": `/product/${Category_9_Products.parentKey}/${Category_9_Products.product_6.key}`
            },
            {
                "title": `${Category_9_Products.product_7.title}`,
                "link": `/product/${Category_9_Products.parentKey}/${Category_9_Products.product_7.key}`
            },
            {
                "title": `${Category_9_Products.product_8.title}`,
                "link": `/product/${Category_9_Products.parentKey}/${Category_9_Products.product_8.key}`
            }
        ]
    },
    {
        "key": `${Category_10_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_10_Products.product_1.title}`,
                "link": `/product/${Category_10_Products.parentKey}/${Category_10_Products.product_1.key}`
            },
            {
                "title": `${Category_10_Products.product_2.title}`,
                "link": `/product/${Category_10_Products.parentKey}/${Category_10_Products.product_2.key}`
            },
            {
                "title": `${Category_10_Products.product_3.title}`,
                "link": `/product/${Category_10_Products.parentKey}/${Category_10_Products.product_3.key}`
            },
            {
                "title": `${Category_10_Products.product_4.title}`,
                "link": `/product/${Category_10_Products.parentKey}/${Category_10_Products.product_4.key}`
            },
            {
                "title": `${Category_10_Products.product_5.title}`,
                "link": `/product/${Category_10_Products.parentKey}/${Category_10_Products.product_5.key}`
            },
            {
                "title": `${Category_10_Products.product_6.title}`,
                "link": `/product/${Category_10_Products.parentKey}/${Category_10_Products.product_6.key}`
            },
            {
                "title": `${Category_10_Products.product_7.title}`,
                "link": `/product/${Category_10_Products.parentKey}/${Category_10_Products.product_7.key}`
            },
            {
                "title": `${Category_10_Products.product_8.title}`,
                "link": `/product/${Category_10_Products.parentKey}/${Category_10_Products.product_8.key}`
            },
            {
                "title": `${Category_10_Products.product_9.title}`,
                "link": `/product/${Category_10_Products.parentKey}/${Category_10_Products.product_9.key}`
            }
        ]
    },
    {
        "key": `${Category_11_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_11_Products.product_1.title}`,
                "link": `/product/${Category_11_Products.parentKey}/${Category_11_Products.product_1.key}`
            },
            {
                "title": `${Category_11_Products.product_2.title}`,
                "link": `/product/${Category_11_Products.parentKey}/${Category_11_Products.product_2.key}`
            },
            {
                "title": `${Category_11_Products.product_3.title}`,
                "link": `/product/${Category_11_Products.parentKey}/${Category_11_Products.product_3.key}`
            },
            {
                "title": `${Category_11_Products.product_4.title}`,
                "link": `/product/${Category_11_Products.parentKey}/${Category_11_Products.product_4.key}`
            },
            {
                "title": `${Category_11_Products.product_5.title}`,
                "link": `/product/${Category_11_Products.parentKey}/${Category_11_Products.product_5.key}`
            },
            {
                "title": `${Category_11_Products.product_6.title}`,
                "link": `/product/${Category_11_Products.parentKey}/${Category_11_Products.product_6.key}`
            }
        ]
    },
    {
        "key": `${Category_12_Products.parentKey}`,
        "subProducts": [
            {
                "title": `${Category_12_Products.product_1.title}`,
                "link": `/product/${Category_12_Products.parentKey}/${Category_12_Products.product_1.key}`
            },
            {
                "title": `${Category_12_Products.product_2.title}`,
                "link": `/product/${Category_12_Products.parentKey}/${Category_12_Products.product_2.key}`
            },
            {
                "title": `${Category_12_Products.product_3.title}`,
                "link": `/product/${Category_12_Products.parentKey}/${Category_12_Products.product_3.key}`
            },
            {
                "title": `${Category_12_Products.product_4.title}`,
                "link": `/product/${Category_12_Products.parentKey}/${Category_12_Products.product_4.key}`
            }
        ]
    },
    {
        "key": `${Category_13_Products.parentKey}`,
        "subProducts": [

        ]
    },
    {
        "key": `${Category_14_Products.parentKey}`,
        "subProducts": [

        ]
    },
    {
        "key": `${Category_15_Products.parentKey}`,
        "subProducts": [

        ]
    },
    {
        "key": `${Category_16_Products.parentKey}`,
        "subProducts": [

        ]
    }
]